import { createFileRoute } from "@tanstack/react-router"
import { CompanyChannels } from "modules/settings/components/channels/CompanyChannels"

export const Route = createFileRoute("/_base/_auth/settings/channels/")({
  component: CompanyChannels,
})
